module.exports = __webpack_public_path__ + "img/bg-certifi.4655f34c.png";